import { jsx as _jsx } from "react/jsx-runtime";
import DeviceLayout from "src/pages/deviceActivate/DeviceLayout";
import AndroidBanafoApp from "src/features/deviceActivate/ActivateApp/AndroidBanafoApp";
const AndroidBanafoActivatePage = () => {
    return (_jsx(DeviceLayout, { children: _jsx(AndroidBanafoApp, {}) }));
};
export default AndroidBanafoActivatePage;
